import baseApi from "./base"
import { PreApplyRequest, PreApplyResponse } from "./types/preApply"
import { Apply1Request, Apply1Response } from "./types/apply"
import { Apply2Request, Apply2Response, ResendOtpRequest, ResendOtpResponse } from "./types/apply2"
import { Apply3Request, Apply3Response } from "./types/apply3"
import { Apply4Request, Apply4Response } from "./types/apply4"
import { EducationStatusRequest, EducationStatusResponse } from "./types/education"
import {
  WorkTypeRequest,
  WorkTypeResponse,
  OccupationRequest,
  OccupationResponse,
  ActivityAreaRequest,
  ActivityAreaResponse,
  JobTitleRequest,
  JobTitleResponse
} from "./types/job"
import { GetCitiesResponse } from "./types/city"
import { GetBranchesRequest, GetBranchesResponse } from "./types/branch"
import { RefreshCaptcha1Request, RefreshCaptcha1Response } from "./types/refreshCaptcha"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetProductInfoRequest, GetProductInfoResponse } from "./types/productInfo"

const functionCode = "BKR0006"
const errorCounter = "3"
const lockHours = "24"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getProductInfo: builder.mutation<GetProductInfoResponse, GetProductInfoRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          urunTip: body.urunTip,
          aracTipi: body.aracTipi,
          cid: body.cid,
          NextTransactionUrl: "Facebook/WebTasit/ProductDetail1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    startApplication: builder.mutation<PreApplyResponse, PreApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          aracTipi: body.aracTipi,
          tasitDegeri: body.tasitDegeri,
          krediTutari: body.krediTutari,
          krediVade: body.krediVade,
          urunTip: body.urunTip,
          cid: body.cid,
          NextTransactionUrl: "Facebook/WebTasit/PreApply1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: functionCode,
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          TokenSessionId: body.TokenSessionId,
          functionCode: functionCode,
          NextTransactionUrl: "Facebook/WebTasit/GetCaptcha1"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<RefreshCaptcha1Response, RefreshCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          functionCode: functionCode,
          NextTransactionUrl: "Facebook/WebTasit/RefreshCaptcha1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply1: builder.mutation<Apply1Response, Apply1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          dogumGun: body.dogumGun,
          dogumAy: body.dogumAy,
          dogumYil: body.dogumYil,
          cepTel: body.cepTel,
          captcha: body.captcha,
          kvkkOnay: body.kvkkOnay,
          callCenter: body.callCenter,
          vade: body.vade,
          tutar: body.tutar,
          urunTip: body.urunTip,
          aracTipi: body.aracTipi,
          cid: body.cid,
          appCode: functionCode,
          errorCount: errorCounter,
          lockHours: lockHours,
          NextTransactionUrl: "Facebook/WebTasit/Apply1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply2: builder.mutation<Apply2Response, Apply2Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          otp: body.otp,
          NextTransactionUrl: "Facebook/WebTasit/Apply2",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          NextTransactionUrl: "Facebook/WebTasit/ResendOtp1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply3: builder.mutation<Apply3Response, Apply3Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          kimlikSeriSiraNo: body.kimlikSeriSiraNo,
          appCode: functionCode,
          errorCount: errorCounter,
          lockHours: lockHours,
          NextTransactionUrl: "Facebook/WebTasit/Apply3",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply4: builder.mutation<Apply4Response, Apply4Request>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          tckn: body.tckn,
          ogrenimDurumu: body.ogrenimDurumu,
          calismaSekli: body.calismaSekli,
          meslek: body.meslek,
          isyeriFaaliyetAlani: body.isyeriFaaliyetAlani,
          unvan: body.unvan,
          aylikNetGelir: body.aylikNetGelir,
          subeKodu: body.subeKodu,
          NextTransactionUrl: "Facebook/WebTasit/Apply4",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCities: builder.mutation<GetCitiesResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/CitiesList1",
          TokenSessionId: body
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getBranches: builder.mutation<GetBranchesResponse, GetBranchesRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          ilKodu: body.cityId,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/BranchesList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getEducationStatuses: builder.mutation<EducationStatusResponse, EducationStatusRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbEducationList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getWorkTypes: builder.mutation<WorkTypeResponse, WorkTypeRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          education: body.education,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbWorkTypeList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getOccupations: builder.mutation<OccupationResponse, OccupationRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          education: body.education,
          workType: body.workType,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbOccupationList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getActivityAreas: builder.mutation<ActivityAreaResponse, ActivityAreaRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          education: body.education,
          occupation: body.occupation,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbActivityAreaList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getJobTitles: builder.mutation<JobTitleResponse, JobTitleRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          education: body.education,
          occupation: body.occupation,
          NextTransactionUrl: "Facebook/SocialMediaPortalStaticData/MbbTitleList1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const {
  useGetProductInfoMutation,
  useGetTokenByTckn1Mutation,
  useGetCaptchaMutation,
  useRefreshCaptchaMutation,
  useStartApplicationMutation,
  useApply1Mutation,
  useApply2Mutation,
  useResendOtpMutation,
  useApply3Mutation,
  useApply4Mutation,
  useGetCitiesMutation,
  useGetBranchesMutation,
  useGetEducationStatusesMutation,
  useGetWorkTypesMutation,
  useGetOccupationsMutation,
  useGetActivityAreasMutation,
  useGetJobTitlesMutation
} = api

export default api
